import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfirm } from '@hooks/useConfirm';

/**
 * The CAD chat is ephemeral: it resets whenever the viewer's model or its
 * comparison target changes, taking the transcript, the unsent draft and the
 * markers with it. Dirtiness is reported up from the chat hook, so it arrives
 * through a setter rather than being readable here.
 */
export function useConfirmDiscardChat() {
  const { t } = useTranslation();
  const confirm = useConfirm();
  const dirtyRef = useRef(false);

  const setChatDirty = useCallback((dirty: boolean) => {
    dirtyRef.current = dirty;
  }, []);

  const confirmDiscardChat = useCallback(
    () =>
      dirtyRef.current
        ? confirm({
            title: t('cad.switchModelConfirm.title'),
            description: t('cad.switchModelConfirm.description'),
            confirmLabel: t('cad.switchModelConfirm.confirm'),
          })
        : Promise.resolve(true),
    [confirm, t],
  );

  return { setChatDirty, confirmDiscardChat };
}
